<template>
    <lay-row space="10">
      <lay-col md="24">
        <lay-panel>
          <lay-form :model="search" style="text-align: start" size="sm">
            <lay-form-item label="名称" prop="username" mode="inline">
            <lay-input v-model="search.key" placeholder="请输入名称"></lay-input>
          </lay-form-item>

            <lay-form-item label="状态" prop="state"  mode="inline">
                <lay-select v-model="search.state">
                    <lay-select-option value="0" label="全部"></lay-select-option>
                    <lay-select-option value="1" label="正常"></lay-select-option>
                    <lay-select-option value="2" label="下架"></lay-select-option> 
                </lay-select>
            </lay-form-item>
            <lay-form-item mode="inline">
              <lay-button type="primary" size="sm" @click="searchUser">查询</lay-button>
            </lay-form-item>
  
          </lay-form>
          <div style="margin-bottom: 10px;text-align: left;">
            <lay-button size="sm" @click="changeVisible11" type="primary">新增</lay-button>
          </div>
  
          <lay-table :page="page" :height="'100%'" :columns="columns" :loading="loading" :data-source="dataSource"
            v-model:selected-keys="selectedKeys" @change="change" @sortChange="sortChange">
 
  
            
            <template #state="{ row }"> 
              <lay-switch :model-value="row.state == 1 ? true : false" @change="changeState(row)" onswitch-text="正常"
              unswitch-text="下架"></lay-switch>
            </template>

            <template v-slot:thumbnail="{ row }">
            <img :src="row.icon"
              @click="signleImg(row.icon)" style="width:62.9px;height:80px" />
          </template>
  
            <template v-slot:operator="{ row }">
              <lay-button size="xs" type="primary" @click="updateAdvertise(row)">编辑</lay-button>
              <lay-button size="xs" type="danger" @click="deleDelTask(row)">删除</lay-button>
            </template>


            <template #type="{ row }">
              <span v-if="row.type==1">签到</span>
              <span v-else-if="row.type==2">新用户</span>
              <span v-else-if="row.type==3">新用户</span>
              <span v-else-if="row.type==4">app下载</span>
              <span v-else-if="row.type==5">服务器验证</span>
              <span v-else-if="row.type==6">系统赠送</span>
            </template>

          </lay-table>
  
  
  
        </lay-panel>
  
      </lay-col>
  
    </lay-row>
    <lay-layer v-model="visible11" :shade="false" :area="['600px', '750px']" :btn="action11" title="添加/修改">
      <div style="padding: 20px;">
        <lay-form :model="advertise" ref="layFormRef11" > 
          <lay-form-item label="图片" prop="title">
            <lay-upload  @done="getUploadFile2" 
            :disabledPreview="false" :multiple="false" acceptMime="image/*"  
            :url="httpUrl+'/common/imgUpload/advertise'" field="file" :headers="headers">
            <template #preview>
              <div class="easy-wrap" v-if="advertise.icon!=''">
                <img :src="advertise.icon"  @click="signleImg(advertise.icon)" style="width:80.9px;height:80.2px"/>
                
              </div>
            </template>
          </lay-upload>
          </lay-form-item> 

          <lay-form-item label="类型" prop="type" mode="inline">
                <lay-select v-model="advertise.type"> 
                    <lay-select-option :value="1" label="签到"></lay-select-option>
                    <lay-select-option :value="2" label="新用户"></lay-select-option>
                    <lay-select-option :value="3" label="邀新"></lay-select-option>
                    <lay-select-option :value="4" label="app下载"></lay-select-option>
                    <lay-select-option :value="5" label="服务器验证"></lay-select-option>
                    <lay-select-option :value="6" label="系统赠送"></lay-select-option>
                </lay-select>
            </lay-form-item>



            <lay-form-item label="设备" prop="multistation" mode="inline">
              <lay-checkbox-group v-model="advertise.multistation">
                    <lay-checkbox name="multistation" :value="1">ios</lay-checkbox>
                    <lay-checkbox name="multistation" :value="2">安卓</lay-checkbox>
                    <lay-checkbox name="multistation"  :value="3">web</lay-checkbox>
                  </lay-checkbox-group>
            </lay-form-item>

            <lay-form-item label="验证类型" prop="verificationBasis" mode="inline">
              <lay-checkbox-group v-model="advertise.verificationBasis">
                    <lay-checkbox name="verificationBasis" :value="1">ip</lay-checkbox>
                    <lay-checkbox name="verificationBasis" :value="2">账号</lay-checkbox>
                    <lay-checkbox name="verificationBasis"  :value="3">设备码</lay-checkbox>
                  </lay-checkbox-group>
            </lay-form-item>
            

          <lay-form-item label="名称" prop="name">
            <lay-input v-model="advertise.name"></lay-input>
          </lay-form-item>  
          <lay-form-item label="说明" prop="caption">
            <lay-input v-model="advertise.caption"></lay-input>
          </lay-form-item> 

          <lay-form-item label="排序" prop="px">
            <lay-input v-model="advertise.px"></lay-input>
          </lay-form-item> 

          <lay-form-item label="ios（分钟）" prop="iosDuration">
            <lay-input v-model="advertise.iosDuration"></lay-input>
          </lay-form-item> 

          <lay-form-item label="web（分钟）" prop="webDuration">
            <lay-input v-model="advertise.webDuration"></lay-input>
          </lay-form-item> 

          <lay-form-item label="安卓（分钟）" prop="androidDuration">
            <lay-input v-model="advertise.androidDuration"></lay-input>
          </lay-form-item> 

          <lay-form-item label="链接" prop="link">
            <lay-input v-model="advertise.link"></lay-input>
          </lay-form-item> 

          <lay-form-item label="预付量" prop="limitAmount">
            <lay-input v-model="advertise.limitAmount"></lay-input>
          </lay-form-item>  
          
          <lay-form-item label="备注" prop="remark">
            <lay-input v-model="advertise.remark"></lay-input>
          </lay-form-item> 
 
  

        </lay-form>
      </div>
    </lay-layer>
  </template>
  
  <script lang="ts" setup>
  import { ref, reactive } from 'vue'
  import { layer } from '@layui/layer-vue'
  import { allTask, addTask,reviseTaskState,delTask} from '../../api'
  import { getToken } from '@/utils/auth'
  import {getUrl} from '../../api/comfig'

  
  const  httpUrl=getUrl();

  const search = reactive({
    key: "",
    state: "0",
  })
 

  
const headers= reactive({
  'token': getToken()
})
  
  const loading = ref(false);
  const dataSource = ref([]);
  const selectedKeys = ref([]);
  const page = reactive({ current: 1, limit: 10, total: 0 });
  const columns = ref([ 
    { title: "图片", key: "icon", align: "center" , customSlot: "thumbnail"},
    { title: "排序", key: "px", align: "center" },
    { title: "名称", key: "name", align: "center" },
    { title: "说明", key: "caption", align: "center" },
    { title: "类型", key: "type", align: "center", customSlot: "type" },
    { title: "状态", key: "state", align: "center", customSlot: "state" }, 
    { title: "ios（分钟）", key: "iosDuration", align: "center" },
    { title: "web（分钟）", key: "webDuration", align: "center" },
    { title: "安卓（分钟）", key: "androidDuration", align: "center" },
    { title: "链接", key: "link", align: "center" },
    { title: "预付量", key: "limitAmount", align: "center" },
    { title: "新量", key: "newQuantity", align: "center" },
    { title: "总完成量", key: "totalAmount", align: "center" },
    { title: "备注", key: "remark", align: "center" },
    { title: "时间", key: "addTime", align: "center" },
    { title: "操作", customSlot: "operator", key: "operator", fixed: "right", align: "center" }
  ]);
  
  const getAllTask = () => {
    loading.value = true;
    var data = { "page": page.current, "limit": page.limit, "key": search.key,"state": search.state };
    allTask(JSON.stringify(data)).then((res: any) => {
      loading.value = false;
      if (res != "" && res.code == 0) {
        dataSource.value = res.data;
        page.total = res.count;
      } else {
        dataSource.value = [];
        page.total = 0;
      }
    })
  }
  //获取数据
  getAllTask();
  
  
  const change = (page: any) => {
    getAllTask();
  }
  
  const sortChange = (key: any, sort: any) => {
    layer.msg(`字段${key} - 排序${sort}, 你可以利用 sort-change 实现服务端排序`)
  }
  

//查看图片

const signleImg = (imgur: any) => {
  layer.photos({
    imgList: [{ src: imgur }]
  })
}
  //查询接口
  const searchUser = () => {
    page.current=1;
    getAllTask();
  }
   
  //修改类型接口
  const changeState = (row: any) => { 
  var data = { "key": row.state, "id":row.id };
  reviseTaskState(JSON.stringify(data)).then((res: any) => {
    if (res != "" && res.code == 0) {
        getAllTask();
      layer.msg("操作成功", { time: 1000, icon: 1 });
    }
  })
}
  
  //上传文件回调方法
  const getUploadFile2 = (res: any) => {
  res = JSON.parse(res.data);
  if (res.code == 0) {
    advertise.icon = res.data.src;
 
    layer.msg("上传成功", { time: 1000, icon: 1 })
  } else {
    layer.msg("上传异常", { icon: 3, time: 1000 })
  }

}
 
  
  const advertise = reactive({
    id:0,
    name: "",
    px:0,
    icon: "",
    caption: "", 
    webDuration: 0, 
    iosDuration: 0,  
    androidDuration:0, 
    link: "", 
    limitAmount: "", 
    remark: "",  
    type:"",
    multistation:[] ,
    verificationBasis:[]
  })
  
  
  const deleDelTask = (row: any) => {
       var data={'id':row.id} 
       delTask(JSON.stringify(data)).then((res: any) => {
          if (res != "" && res.code == 0) {
            getAllTask(); 
            layer.msg("操作成功", { time: 1000, icon: 1 });
          }
        })
   
  }
  
  const layFormRef11 = ref();
  
  const visible11 = ref(false);
  
  const isDisabled = ref(false);

  const updateAdvertise= (row: any) => {

    advertise.id = row.id;
    advertise.px = row.px;
    advertise.name =row.name;
    advertise.icon = row.icon;
    advertise.caption =row.caption;
    advertise.webDuration =row.webDuration;
    advertise.iosDuration = row.iosDuration;
    advertise.androidDuration = row.androidDuration;
    advertise.link = row.link;
    advertise.remark = row.remark;
    advertise.limitAmount = row.limitAmount;
    advertise.type = row.type; 
     if (row.multistation) {
      let uniqueArr: number[] = row.multistation.split(",").map(Number);
    advertise.multistation = uniqueArr;
     }
     
     if (row.verificationBasis) {
      let verificationBasisuniqueArr: number[] = row.verificationBasis.split(",").map(Number);
    advertise.verificationBasis = verificationBasisuniqueArr;
     }

  
    
    
    isDisabled.value = false;
    visible11.value = !visible11.value;
  }
  
  const changeVisible11 = () => {
    advertise.id = 0;
    advertise.px = 0;
    advertise.name = "";
    advertise.icon = "";
    advertise.caption = "下载“***”并安装成功可领取会员时长";
    advertise.webDuration = 0;
    advertise.iosDuration = 0;
    advertise.androidDuration = 0;
    advertise.link = "";
    advertise.limitAmount = "";
    advertise.remark = "";
    advertise.type="",
    advertise.verificationBasis=[],
    advertise.multistation=[]
  
  
    isDisabled.value = false;
    visible11.value = !visible11.value;
  }
  
  const action11 = ref([
    {
      text: "确认",
      callback: () => {

        if (advertise.verificationBasis.length!=0) {
      let verificationBasisuniqueArr: number[] =  [...new Set(advertise.verificationBasis)];
    advertise.verificationBasis = verificationBasisuniqueArr.join(", ")
     }else{
      advertise.verificationBasis ="";
     }

     if (advertise.multistation.length!=0) {
      let multistationuniqueArr: number[] = [...new Set(advertise.multistation)];
        advertise.multistation= multistationuniqueArr.join(", ")
     }else{
      advertise.multistation ="";
     }
       

      

        addTask(JSON.stringify(advertise)).then((res: any) => {
          if (res != "" && res.code == 0) {
            getAllTask();
            visible11.value = false;
            layer.msg("操作成功", { time: 1000, icon: 1 });
          }
        })
      }
    },
    {
      text: "取消",
      callback: () => {
        visible11.value = false;
  
  
      }
    }
  ])
  
  
  </script>
  
  <style scoped></style>